
import { Injectable } from '@angular/core';
import { WindlogForecastAvailableGQL } from '../../graphql';
import { map, take } from 'rxjs/operators';
import { ForecastParksWinglogProvider } from 'app/models/forecast/forecast-parks-windlog-provider.model';

@Injectable({
  providedIn: 'root'
})
export class ForecastWindlogProviderAvailabilityService {

    private parksWithWindlogProvider: ForecastParksWinglogProvider[];

    constructor(private windlogForecastAvailableGQL: WindlogForecastAvailableGQL) {}

    public getParksWithWindlogForecastAvailableQuery(): Promise<boolean> {
      return this.windlogForecastAvailableGQL.fetch()
        .pipe(take(1), map(d => ForecastParksWinglogProvider.mapData(d?.data?.parks)))
        .toPromise().then((data: ForecastParksWinglogProvider[]) => {
          this.parksWithWindlogProvider = data
          return true;
        })
    }

    public getParksWithWindlogForecastAvailable(): ForecastParksWinglogProvider[] {
      return this.parksWithWindlogProvider || [];
    }
}
